import { createFileRoute } from "@tanstack/react-router";
import { ReportsLibrary, reportsHead } from "@/components/ReportsLibrary";
import { listPublishedReports } from "@/lib/reports.functions";

export const Route = createFileRoute("/raporlar/")({
  // SSR the curated report library. The query cache is not shipped to the
  // browser, so the data is also returned as loader data and used to seed the
  // component's query — server and client then render identical HTML.
  loader: async ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: ["public-reports"],
      queryFn: () => listPublishedReports(),
    }),
  head: () => reportsHead("tr"),
  component: RaporlarPage,
});

function RaporlarPage() {
  return <ReportsLibrary lang="tr" initialData={Route.useLoaderData()} />;
}
